/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_History_ReferrerInputs */

const en_admin_funnel_footnote_history_referrer = /** @type {(inputs: Admin_Funnel_Footnote_History_ReferrerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referrers come from the browser's Referer header. ChatGPT strips it, so most ChatGPT clicks show as direct here; the user table's utm_source (chatgpt.com) is the reliable ChatGPT signal. /admin pages are excluded from traffic and the top pages list.`)
};

/**
* | output |
* | --- |
* | "Referrers come from the browser's Referer header. ChatGPT strips it, so most ChatGPT clicks show as direct here; the user table's utm_source (chatgpt.com) is..." |
*
* @param {Admin_Funnel_Footnote_History_ReferrerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_history_referrer = /** @type {((inputs?: Admin_Funnel_Footnote_History_ReferrerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_History_ReferrerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_history_referrer(inputs)
});
export { admin_funnel_footnote_history_referrer as "admin.funnel.footnote.history_referrer" }